import { BUSCAR_ITINERARIOS_ABERTOS_ENCOMENDA_AVULSA } from '../../actions/types'

const initial = []

export default function reducerItinerariosAbertosEncomendaAvulsa (state = initial, action = {}) {
  switch (action.type) {
    case BUSCAR_ITINERARIOS_ABERTOS_ENCOMENDA_AVULSA: {
      return action.payload || []
    }

    default:
      return state
  }
}
